import { Component, OnInit, Input, Output, OnChanges, EventEmitter, SimpleChanges, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CaseOverviewCase } from '../../cases/cases.component';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { CaseDetails } from '../details/details.component';
import * as api from '../../shared/api/apihandler';
import { DevelopmentHelpers } from '../../shared/utilities/developHelpers';
import { SubscriptionObject } from 'app/shared/models/standard.models';

@Component({
  selector: 'case-search',
  templateUrl: './case-search.component.html',
  styleUrls: ['./case-search.component.css'],
})
export class CaseSearchComponent implements OnInit, OnChanges, OnDestroy {

  @Output('case') chosen = new EventEmitter();
  @Input('options') options = new CaseSearchOutputOptions();
  @Input() small;
  @Input() default;
  @Input('caseId') caseId: string;
  @Input('inputId') inputId: string;
  @Output() customer = new EventEmitter();
  allCases: Array<CaseOverviewCase> = [];
  output: Array<CaseOverviewCase> = [];
  whichCase: string = '';
  gettingCases = false;
  offset = -240;
  chosenCase: CaseOverviewCase = null;
  companyInfo;
  help = new DevelopmentHelpers();
  uniqueId = this.help.guid.newGUID()
  viewAmount = 10;
  isSearching = false;
  subs: SubscriptionObject = {}

  constructor(private httpClient: HttpClient, private sharedData: SharedDataService) {
  }

  ngOnInit() {
    this.subs['companyInformation'] = this.sharedData.companyInformation().subscribe(data => { this.companyInfo = data; })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes.caseId && changes.caseId.currentValue != null) {
      this.getSingleCase(this.caseId);
    } else if (!!changes.caseId && changes.caseId.currentValue == null && this.chosenCase != null) {
      this.chosenCase = null;
    }
    else if(!!changes.options && !!changes.options.currentValue){
      if(this.options.hideSearch){ this.isSearching = true}
    }

    if(changes.inputId && !!changes.inputId.currentValue) this.uniqueId = this.inputId;
  }

  ngOnDestroy(): void {
    for(let key of Object.keys(this.subs)) this.subs[key].unsubscribe();
  }

  close() {
    this.whichCase = '';
    this.chosenCase = null;
    let a = document.getElementById('searchCaseModal' + this.uniqueId);
    a.click();
    this.isSearching = false;
  }

  getCases() {
    this.gettingCases = true;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Case/CaseListOverview', { headers }).subscribe(
      (data: Array<CaseOverviewCase>) => {
        // should transform with orderPipe
        this.allCases = data.sort((a,b)=>{
          if(!a.caseNumber || !b.caseNumber) {
            if(!a.caseNumber && !b.caseNumber) return 0
            else return !a.caseNumber ? 1 : -1
          }
          else if(!!+a.caseNumber && !!+b.caseNumber){ return +a.caseNumber < +b.caseNumber ? -1 : 1  }
          else return a.caseNumber.toLowerCase() < b.caseNumber.toLowerCase() ? -1 : 1
        });
        this.filter()
      },
      () => { },
      () => {
        if (this.options.preselected != null) {
          this.chosenCase = this.allCases.find(x => x.caseId == this.caseId);
        }
        this.gettingCases = false;
      }
    );
  }

  filter(){
    if(!this.whichCase) {
      this.output = this.allCases.slice(0,9); 
    }
    else {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.get(api.jubloApi + '/api/Website/Case/SearchCases?search=' + this.whichCase,{headers}).subscribe(
        (data:any)=> {
          this.output = !!data ? data : [];
        }
      )
    }
  }

  getSingleCase(id) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Case/CaseDetails/' + id, { headers }).subscribe((data: CaseDetails) => {
      this.chosenCase = {
        unreadPartnerMessage: data.unreadPartnerMessage,
        activities: null,
        caseId: data.caseId,
        caseNumber: data.caseNumber,
        caseType: data.caseType,
        companyName: data.companyName,
        createdAt: data.createdAt,
        lastModified: data.lastModified,
        customer: data.customer,
        deliveryAddress: data.deliveryAddress,
        description: data.description,
        disableNotifications: data.disableNotifications,
        disableNotification: data.disableNotification,
        externalId: data.externalId,
        fitter: data.fitter,
        lastMessage: null,
        offerId: data.offerId,
        origin: data.origin,
        responsible: data.responsible,
        startTime: null,
        status: null,
        title: data.title,
        tempCaseNumber: null,
        parsedDescription: null,
        unreadMessage: null,
        requisitionNumber: data.requisitionNumber,
        propertyInfo: data.propertyInfo
      };
    },
      () => { },
      () => { this.chosen.emit(this.chosenCase);this.customer.emit(this.chosenCase.customer) }
    )
  }

  restrictViewAmount(array) {
    if (array.length > this.viewAmount) {
      this.output = array.slice(0, this.viewAmount)
    }
    else { this.output = array }
  }

  chooseCase(c: any) {
    this.getSingleCase(c.caseId ? c.caseId : c.id);
    this.output = [];

    this.close();
  }

}


export class CaseSearchOutputOptions {
  offset: number = 0;
  maxHeight: number = 70;
  bottom: number = null;
  preselected: string = null;
  hideSearch: boolean = false;
  buttonClass: string = null;
}
